import type { RequestParameters } from "#shopware";
import { useListing as swUseListing } from "@shopware/composables";

export function useListing(params?: {
  listingType: ListingType;
  categoryId?: string;
  defaultSearchCriteria?: RequestParameters<"searchPage">;
}) {
  const coreFunctionality = swUseListing(params);

  const getTotal = computed(() => {
    return coreFunctionality.getCurrentListing.value?.total;
  });

  return {
    ...coreFunctionality,
    getTotal,
  };
}
